import './App.css'
import { Routes, Route, Navigate } from 'react-router-dom'
import LandingPage from './pages/LandingPage'
import GetQuote from './pages/GetQuote'
import ShowerBaseOrder from './pages/ShowerBaseOrder'
import SiteHeader from './components/SiteHeader'

function App() {
  return (
    <div className="site-shell">
      <SiteHeader />
      <main className="site-main">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/get-a-quote" element={<GetQuote />} />
          <Route path="/shower-base-quote" element={<GetQuote />} />
          <Route path="/shower-base-order" element={<ShowerBaseOrder />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  )
}

export default App
